/**
 * @flow
 * @relayHash 5eb4d587e65518850fd4d636140c1c2a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POUploadStatus = "CONFIRMED" | "FAILED" | "PROCESSING" | "READY_FOR_REVIEW";
export type POUploadSceneUploadsQueryVariables = {||};
export type POUploadSceneUploadsQueryResponse = {|
  +poUploads: $ReadOnlyArray<{|
    +poUploadId: string,
    +fileName: string,
    +fileUrl: string,
    +status: POUploadStatus,
    +errorMessage: ?string,
    +extractedData: ?any,
    +orderId: ?string,
    +createdAt: any,
  |}>
|};
export type POUploadSceneUploadsQuery = {|
  variables: POUploadSceneUploadsQueryVariables,
  response: POUploadSceneUploadsQueryResponse,
|};
*/


/*
query POUploadSceneUploadsQuery {
  poUploads {
    poUploadId
    fileName
    fileUrl
    status
    errorMessage
    extractedData
    orderId
    createdAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "poUploads",
    "storageKey": null,
    "args": null,
    "concreteType": "POUpload",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "poUploadId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "fileName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "fileUrl",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "errorMessage",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "extractedData",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "orderId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "createdAt",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "POUploadSceneUploadsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "POUploadSceneUploadsQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "POUploadSceneUploadsQuery",
    "id": null,
    "text": "query POUploadSceneUploadsQuery {\n  poUploads {\n    poUploadId\n    fileName\n    fileUrl\n    status\n    errorMessage\n    extractedData\n    orderId\n    createdAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8d05cdff6066daf548755029c6190af4';
module.exports = node;
